"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatMessage = void 0;
const core_1 = require("@hyper-hyper-space/core");
// A message from a given author, to be used within ChatRooms.
class ChatMessage extends core_1.HashedObject {
    constructor(author, text, timestamp) {
        super();
        if (author !== undefined) {
            this.setAuthor(author);
            this.text = text;
            this.timestamp = timestamp !== undefined ? timestamp : Date.now();
        }
    }
    getClassName() {
        return ChatMessage.className;
    }
    init() {
    }
    async validate(_references) {
        return this.text !== undefined && this.getAuthor() !== undefined && this.timestamp !== undefined;
    }
}
exports.ChatMessage = ChatMessage;
ChatMessage.className = 'p2p-chat/v0/model/ChatMessage';
core_1.HashedObject.registerClass(ChatMessage.className, ChatMessage);
//# sourceMappingURL=ChatMessage.js.map